import React, { useCallback } from 'react';
import { styled } from '@mui/material';
import { Link, LinkProps, useLocation } from 'react-router-dom';
import { exitPoint as setExitPoint } from '@/actions/common';

type CustomLinkProps = LinkProps & { exitPoint?: true };

const CustomLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: 'inherit',
}));

export default ({
  children, exitPoint, ...props
}: CustomLinkProps) => {
  const location = useLocation();
  const beforeClick = useCallback(() => {
    setExitPoint(location);
  }, []);
  return <CustomLink {...props} onClick={exitPoint ? beforeClick : undefined}>
    {children}
  </CustomLink>
};
